var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAnonVoter(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_577_80135)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    rx: 24,
    fill: "#ECF7F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36 14H11V30H36V14Z",
    fill: "#AADDD5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33 11H14V28H33V11Z",
    fill: "#AADDD5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34 32H18V51H34V32Z",
    fill: "#AADDD5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 32H13V51H16V32Z",
    fill: "#AADDD5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18 32H16V37H18V32Z",
    fill: "#AADDD5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.8969 17.125H24.6907V19.7229H26.2062V17.125H34V24.9188H26.2062V21.0219H24.6907V24.9188H16.8969V21.0219H14.299V23.6198H13V19.7229H16.8969V17.125Z",
    fill: "#8FC4BB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.7945 18.4238H18.4131V23.6197H20.7945V18.4238Z",
    fill: "#ECF7F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.103 18.4238H27.2886V23.6197H30.103V18.4238Z",
    fill: "#ECF7F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.3914 18.4238H20.7935V23.6197H23.3914V18.4238Z",
    fill: "#8FC4BB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.7015 18.4238H30.1035V23.6197H32.7015V18.4238Z",
    fill: "#8FC4BB"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_577_80135"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    rx: 24,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnonVoter);
export default __webpack_public_path__ + "static/media/anonVoter.364254e6edd038948fab5cb6916ca194.svg";
export { ForwardRef as ReactComponent };